import { AgencyId, Dtos } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { adminAgentPreviewsQueryKey } from "../agency.keys";

export const useAdminInviteAgent = () => {
	const queryClient = useQueryClient();
	const { post } = useRequest();

	const mutation = useMutation({
		mutationFn: async ({
			agencyId,
			data,
		}: {
			agencyId: AgencyId;
			data: Dtos.Agent.Invite.Request;
		}) => await post(`/v2/admin/agencies/${agencyId}/agents/invite`, data, "none"),
		onSuccess: async () => {
			queryClient.invalidateQueries({ queryKey: adminAgentPreviewsQueryKey() });
		},
	});

	return {
		adminInviteAgent: mutation.mutate,
		adminInviteAgentIsLoading: mutation.isPending,
		adminInviteAgentError: mutation.error,
		adminInviteAgentIsSuccess: mutation.isSuccess,
	};
};
